import { defineComponent as _defineComponent } from 'vue'
import AdminNavigation from "../../AdminNavigationContainer.vue";
import { ref, onMounted, onBeforeUnmount, reactive, onUpdated } from "vue";
import { useI18n } from "vue3-i18n";
import ResponseData from "@/types/ResponseData";
import Loading from "@/components/home/Loading.vue";
import Alert from "@/components/scan/parts/Alert.vue";
import UserInfoDataService from "@/services/UserInfoDataService";
import { store } from "@/store/store";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const isLoading = ref(false);
const alertMessage = ref("null");
const alertState = ref("neutral");
const i18n = useI18n();
const title = ref(store.getters.showPageTitle);
const distAdminListInfo = reactive([]);
const getData = ref(false);

/** 初期表示設定 */
onMounted(function () {
  window.addEventListener('resize', handleResize);
  isLoading.value = true;
  getDistAdminList();
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize);
});

function handleResize() {
  store.dispatch("setIsPageLoad", false);
  try {
    var tableHeight = 0;
    var dataHeight = document.getElementById("tbltbody")?.clientHeight;
    if (dataHeight != 0) {
      var mydivh = document.getElementById("mydiv")?.clientHeight;
      tableHeight = (mydivh * 96) / 100 - 200;
      if (dataHeight > tableHeight) {
        document.getElementById("tblAdminBodyDiv").style.width = "100%";
      } else {
        document.getElementById("tblAdminBodyDiv").style.width = "calc(100% - 16px)";
      }
    }
  } catch (e) {
    isLoading.value = false;
  }
}

/** Dist Adminリスト取得 */
const getDistAdminList = () => {
  isLoading.value = true;
  distAdminListInfo.splice(0);

  //二回目実行にアラートメッセージが表示修正
  alertMessage.value = "null";
  alertState.value = "neutral";

  if(store.getters.companyAdminListData != null && store.getters.isPageLoad == false ){
    distAdminListInfo.push(store.getters.companyAdminListData);
    getData.value = true;
    isLoading.value = false;
  }else{
    // Dist Admin情報取得
    UserInfoDataService.getDistAdminList()
      .then((response: ResponseData) => {
        if (response.data.length !== 0) {
          store.dispatch("setCompanyAdminListData",response.data);
          distAdminListInfo.push(response.data);
        }
        getData.value = true;
        isLoading.value = false;
      })
      .catch((e: Error) => {
        console.log(e);
        alertMessage.value = i18n.t("err012");
        alertState.value = "error";
        isLoading.value = false;
      });
  }
};

onUpdated(function () {
  handleResize();
});

const addAdminUser = () => {
  store.dispatch("setShowPage", "DistAdminRegisteration");
  store.dispatch("setShowPageTitle", "Company Admin Maintenance");
};

const __returned__ = { isLoading, alertMessage, alertState, i18n, title, distAdminListInfo, getData, handleResize, getDistAdminList, addAdminUser, AdminNavigation, Loading, Alert }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})